// extracted by mini-css-extract-plugin
export default {"modalBackground":"modal_modalBackground__yq8S7","modal":"modal_modal__IGpX0"};